// import { WrappedScopeDetailPage } from './lib/ScopeDetail';
import { WrappedScopeDetailPage } from './lib/ScopeDetail2';

export * from './lib/components';
export default WrappedScopeDetailPage;
